import React, { useEffect, useMemo, useRef, useState } from 'react';

import '../css/header.css';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 840);
  const [isScrolled, setIsScrolled] = useState(false);
  // 윈도우 크기 변경 시 isMobile 상태 업데이트
  const location = useLocation(); // 현재 경로 가져오기
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 840);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 스크롤 이벤트 핸들러
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY === 0); // 스크롤 위치에 따라 상태 업데이트
    };

    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  const menu_open = () => {
    const submenu = document.getElementById('slide_menu');
    const cloudLayer = document.getElementById('cloudlayer');

    submenu.style.height = `${document.documentElement.scrollHeight}px`;
    // 서브 메뉴의 현재 left 값을 가져옵니다.
    const submenuLeft = getComputedStyle(submenu).left;

    // 메뉴 열기/닫기 로직
    if (submenuLeft === '-690px') {
      submenu.style.transition = 'left 0.5s';
      submenu.style.left = '0px'; // 메뉴 열기
      cloudLayer.style.height = `${document.documentElement.scrollHeight}px`;
      cloudLayer.style.display = 'block'; // 클라우드 레이어 표시
    }
  };


  const menu_close = () => {
    const submenu = document.getElementById('slide_menu');
    const cloudLayer = document.getElementById('cloudlayer');

    submenu.style.transition = 'left 0.5s';
    submenu.style.left = '-690px'; // 메뉴 닫기
    cloudLayer.style.display = 'none'; // 클라우드 레이어 숨기기
  };


  const [openSubmenu, setOpenSubmenu] = useState({
    submenu01: false,
    submenu02: false,
    submenu03: false,
    submenu06: false,
  });

  const submenu01Ref = useRef(null);
  const submenu02Ref = useRef(null);
  const submenu03Ref = useRef(null);
  const submenu06Ref = useRef(null);

  const submenuRefs = useMemo(() => ({
    submenu01: submenu01Ref,
    submenu02: submenu02Ref,
    submenu03: submenu03Ref,
    submenu06: submenu06Ref,
  }), []);

  const handleToggle = (submenu) => {
    setOpenSubmenu((prev) => ({
      ...prev,
      [submenu]: !prev[submenu],
    }));
  };

  useEffect(() => {
    Object.keys(openSubmenu).forEach((key) => {
      const submenu = submenuRefs[key].current;
      if (submenu) {
        submenu.style.maxHeight = openSubmenu[key] ? `${submenu.scrollHeight}px` : '0px';
      }
    });
  }, [openSubmenu, submenuRefs]);

  const isHome = location.pathname === '/';
  // const [openSubmenu, setOpenSubmenu] = useState(null);

  // const handleToggle = (submenu) => {
  //   setOpenSubmenu(openSubmenu === submenu ? null : submenu);
  // };

  return (
    <>
      {/* 모바일 사이즈 */}
      {isMobile && (

        <div id="m_hd_wrapper" style={{ display: 'none' }}>
          <div id="m_logo">
            <Link to={"/"}><img style={{ width: '100%' }} src="/img10/logo.png" alt="Logo" title="" /></Link>
          </div>
          <div id="m_gnb_open" className="hd_opener">
            <img style={{ width: '100%', marginTop: 4 }} src="/img10/m_menu.png" onClick={menu_open} alt='MobileMenu' />
          </div>

          <div id="m_call">
            <a href="tel:1800.1321"><img src="/img10/m_call.png" alt='MobileCall' /></a>
          </div>

          <div id="slide_menu" className="submenu_wrap" style={{ height: 2213 }}
          >
            <div className="logo_wrap">
              <div id="m_logo2">
                <img style={{ width: '100%' }} src="/img10/logo.png" alt='Logo' />
              </div>
              <div id="m_close">
                <img style={{ width: '100%' }} src="/img10/m_close.png" onClick={menu_close} alt='MobileClose' />
              </div>
            </div>


            <div className="select select--white">
              <span className="placeholder submenu01" onClick={() => handleToggle('submenu01')}>홈으로</span>
              {/* {openSubmenu === 'submenu01' && (
                <div>
                  <ul>
                    <Link to="/"><li>메인으로 이동</li></Link>
                  </ul>
                </div>
              )} */}
              <div
                className={`submenu ${openSubmenu.submenu01 ? 'open' : ''}`}
                ref={submenuRefs.submenu01}
              >
                <ul>
                  <Link to="/" onClick={menu_close}><li>메인으로 이동</li></Link>
                </ul>
              </div>
            </div>
            <div className="select select--white">
              <span className="placeholder submenu02" onClick={() => handleToggle('submenu02')}>문의하기</span>
              <div
                ref={submenuRefs.submenu02}
                className={`submenu ${openSubmenu.submenu02 ? 'open' : ''}`}
              >
                <ul>
                  <Link to="/inquiry/1" onClick={menu_close}><li>지점개설</li></Link>
                  <Link to="/inquiry/2" onClick={menu_close}><li>상점안내</li></Link>
                  <Link to="/inquiry/3" onClick={menu_close}><li>라이더문의</li></Link>
                  <Link to="/inquiry/4" onClick={menu_close}><li>기타제휴</li></Link>
                </ul>
              </div>
              {/* {openSubmenu === 'submenu02' && (
                <div>
                  <ul>
                    <Link to="/inquiry"><li>지점개설</li></Link>
                    <Link to="/inquiry"><li>상점안내</li></Link>
                    <Link to="/inquiry"><li>라이더문의</li></Link>
                    <Link to="/inquiry"><li>기타제휴</li></Link>
                  </ul>
                </div>
              )} */}
            </div>
            <div className="select select--white">
              <span className="placeholder submenu06" onClick={() => handleToggle('submenu06')}>다운로드</span>
              <div
                className={`submenu ${openSubmenu.submenu06 ? 'open' : ''}`}
                ref={submenuRefs.submenu06}
              >
                <ul>
                  <Link to="/download/1" onClick={menu_close}><li>다운로드</li></Link>
                  <Link to="/download/2" onClick={menu_close}><li>설치가이드</li></Link>
                </ul>
              </div>
              {/* {openSubmenu === 'submenu06' && (
                <div>
                  <ul>
                    <Link to="/download"><li>다운로드</li></Link>
                    <Link to="/download"><li>설치가이드</li></Link>
                  </ul>
                </div>
              )} */}
            </div>
            <div className="select select--white">
              <span className="placeholder submenu03" onClick={() => handleToggle('submenu03')}>고객센터</span>
              <div
                className={`submenu ${openSubmenu.submenu03 ? 'open' : ''}`}
                ref={submenuRefs.submenu03}
              >
                <ul>
                  <Link to="/notice" onClick={menu_close}><li>공지사항</li></Link>
                </ul>
              </div>
              {/* {openSubmenu === 'submenu03' && (
                <div>
                  <ul>
                    <Link to="/notice"><li>공지사항</li></Link>
                  </ul>
                </div>
              )} */}
            </div>

          </div>

          <div id="cloudlayer"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              background: '#000',
              opacity: 0.5,
              filter: 'alpha(opacity=0.5)',
              width: '100%',
              height: '100%',
              zIndex: 500,
              display: 'none'
            }}>

          </div>
        </div>

      )}

      {/* PC 사이즈 */}
      {!isMobile && (
        // <div className="header">
        <div className={`header ${isScrolled && isHome ? 'scrolled' : ''}`}>
          <div className="navi">
            <div className="logo">
              <Link to={"/"}><img src="/img10/logo.png" alt='Logo' /></Link>
            </div>
            <div className="menu">
              <ul>
                <li><Link to={"/notice"}>공지사항</Link></li>
                <li><Link to={"/download"}>다운로드</Link></li>
                <li><Link to={"/inquiry"}>문의하기</Link></li>
                <li><Link to={"/"}>홈으로</Link></li>
              </ul>
            </div>
          </div>
        </div>
      )}

    </>

  );
}

export default Header;
